import axios, { AxiosRequestConfig } from 'axios';
import React, { createRef, useEffect, useRef, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Container, FormGroup, Label, InputFile, Input } from "reactstrap";
import InputFileUpload from './InputFileUploadComponent';
//URL
import configData from "../../../config.json";
import { authenticationService } from 'services/authentication.service';
import { alertService } from 'components/Varios/alert_service';
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';

export type DatosModalFirmarReporteAnual = {
    urlPDF: string,
    archivoPDF: File | null

}

type PropsModalFirmarReporteAnual = {
    show: boolean,
    toogle: () => void,
    onClose: () => void,
    datosModal: DatosModalFirmarReporteAnual,
}


export type FileInfo = {
    nombreFile: string,
    file: File,
    id: string
}

export type FileInfoUrl = {
    nombreFile: string,
    file: File,
    id: string,
    url: string
}






const ModalFirmarReporteAnual: React.FC<PropsModalFirmarReporteAnual> = (props: PropsModalFirmarReporteAnual) => {

    const ButtonAcept: React.RefObject<HTMLButtonElement> = createRef();

    const [filesEnviar, setfilesEnviar] = useState<FileInfoUrl[]>([])
    const [contrasenia, setContrasenia] = useState<string>("")
    const [mostrarConfirmacionFirma, setmostrarConfirmacionFirma] = useState<boolean>(false);


    function CerrarModal() {
        setfilesEnviar([]);
        setContrasenia("");
        setmostrarConfirmacionFirma(false);
        props.toogle();
    }

    function handleChangeContra(e: string) {
        var _contrasenia_ = new TextEncoder().encode(e).toString();

        setContrasenia(_contrasenia_)
    }



    function handleFileUploadChange(archivo: FileInfo) {
        var uploadFile = new File([archivo.file], archivo.id + ".pdf");

        const src = window.URL.createObjectURL(uploadFile);

        const firmaArchivoInfo: FileInfoUrl = {
            nombreFile: archivo.nombreFile,
            file: uploadFile,
            id: archivo.id,
            url: src
        };

        setfilesEnviar([...filesEnviar, firmaArchivoInfo])
    }
    async function FirmarDocumento() {
        var botonAceptar = document.getElementById("botonAceptar");
        var botonCancelar = document.getElementById("botonCancelar");
        var contenedor_errores = document.getElementById("contenedor_errores");

        if (filesEnviar.length !== 2) {
            if (botonAceptar && botonCancelar && contenedor_errores) {
                const small_texto = document.createElement("small");
                small_texto.id = "error_certificado"
                small_texto.innerText = "Debe adjuntar su firma/certificado electrónica\n";
                if (contenedor_errores) {
                    while (contenedor_errores.firstChild) {
                        if (contenedor_errores.lastChild != null) {
                            contenedor_errores.removeChild(contenedor_errores.lastChild);

                        }
                    }
                    contenedor_errores.append(small_texto);
                }
            }
            return false
        }

        if (contrasenia === "" || contrasenia === undefined || contrasenia === null) {
            const small_texto = document.createElement("small");
            small_texto.innerText = "Debe ingresar su contraseña\n";
            if (contenedor_errores) {
                while (contenedor_errores.firstChild) {
                    if (contenedor_errores.lastChild != null) {
                        contenedor_errores.removeChild(contenedor_errores.lastChild);

                    }
                }
                contenedor_errores.append(small_texto);
            }
            return false
        }

        const i = document.createElement("i");
        i.setAttribute("id", "loadingEnviar")
        i.setAttribute("class", "fa fa-spin fa-spinner")
        if (botonAceptar && botonCancelar) {
            botonAceptar.textContent = "Enviando... "
            botonAceptar.insertBefore(i, null)
            botonAceptar.setAttribute("disabled", "true")
            botonCancelar.setAttribute("disabled", "true")
        }

        var currentUser = authenticationService.currentUserValue;

        if (props.datosModal.archivoPDF === null || props.datosModal.archivoPDF === undefined) {
            return false;
        }
        else {
            const formData = new FormData();
            formData.append("files", filesEnviar[0].file, filesEnviar[0].file.name);
            formData.append("files", filesEnviar[1].file, filesEnviar[1].file.name);
            formData.append("contrasenia", contrasenia)

            let instance = axios.create({ baseURL: configData.SERVER_URL });
            let options: AxiosRequestConfig = {
                url: `PlanificacionVacaciones/Administrador/FirmarReporte/`,
                data: formData,
                method: "POST",
                responseType: "blob",
                headers: {
                    Authorization: `KEYESPOL ${currentUser?.token}`
                }
                // don't forget this
            };
            try {
                await instance.request<any>(options).then((response) => {
                    let url = window.URL.createObjectURL(new Blob([response.data]));
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "reporte_planificacion_anual.pdf"  //nombrearchivo
                    a.click()
                    window.location.reload();
                });
                if (botonAceptar && botonCancelar) {
                    botonAceptar.textContent = "Enviado"
                    botonAceptar.setAttribute("disabled", "true")
                    botonCancelar.setAttribute("disabled", "false")
                }
                setmostrarConfirmacionFirma(true);
                return true;
            } catch (error) {
                var error_any: any = error;
                var status_number = handle_error(error_any);
                var mensaje_error: string = "Error desconocido. Intente más tarde";
                switch (status_number) {
                    case 500:
                        mensaje_error = "Error inesperado. Intente más tarde"
                        break;
                    case 0:
                        mensaje_error = "No ha sido posible conectarse con el servidor. Intente más tarde"
                    case 401:
                        mensaje_error = "No está autorizado a realizar esta acción";
                    case 409:
                        mensaje_error = await new Blob([error_any.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
                    default:
                        break;
                }

                if (contenedor_errores) {
                    const small_texto = document.createElement("small");
                    small_texto.innerText = mensaje_error + "\n";
                    while (contenedor_errores.firstChild) {
                        if (contenedor_errores.lastChild != null) {
                            contenedor_errores.removeChild(contenedor_errores.lastChild);

                        }
                    }
                    contenedor_errores.append(small_texto);
                }
                if (botonAceptar && botonCancelar) {
                    // botonAceptar.textContent = "Intentar de nuevo"
                    botonCancelar.removeAttribute("disabled")
                    botonAceptar.removeAttribute("disabled")
                    i.remove();
                    botonAceptar.textContent = "Guardar"
                }


            }

        }







    }


    useEffect(() => {
        if (props.datosModal.archivoPDF !== null) {
            const { archivoPDF, urlPDF } = props.datosModal
            setfilesEnviar([...filesEnviar, {
                file: archivoPDF,
                id: "11",
                url: urlPDF,
                nombreFile: "asqawsa"
            }])
        }
    }, [props.datosModal.archivoPDF])



    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"xl "}
            fullscreen={"xl"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={<button onClick={() => CerrarModal()} >x</button>} >
                Reporte Planificación Anual Vacaciones
            </ModalHeader>

            <ModalBody>
                {
                    props.datosModal.urlPDF != "" && !mostrarConfirmacionFirma &&
                    <React.Fragment>

                        <div style={{ overflowX: "auto" }} className="row text-center mb-3">
                            <object data={props.datosModal.urlPDF} type="application/pdf" width="100%" height="400">
                            </object>
                        </div>

                        <Row form className="mt-3">
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="nombremencion">Certificado*</Label>
                                    <InputFileUpload
                                        icon="upload"
                                        onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                        name="DOC"
                                        id="CERT"
                                        placeholder="Subir firma electrónica"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="nombremencion">Contraseña*</Label>
                                    <Input
                                        type="password"
                                        name="contrasenia"
                                        id="contrasenia"
                                        placeholder=""
                                        onChange={(e) => handleChangeContra(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div id="contenedor_errores" className="errores_firmar">

                        </div>
                        <Button color="primary" id="botonAceptar" onClick={() => FirmarDocumento()} ref={ButtonAcept} >Guardar</Button>

                        <Button color="secondary" id="botonCancelar" onClick={() => CerrarModal()}>Cancelar</Button>

                    </React.Fragment>
                }
                {
                    mostrarConfirmacionFirma &&
                    <React.Fragment>
                        <Row className ="justify-content-center">
                            <Col sm={12} md= {12} xl ={10} className ="text-center">
                                El documento se ha firmado correctamente. Espere un momento por favor. 
                            </Col>
                            
                        </Row>
                        <Row className ="justify-content-center">
                        <Col sm={12} md= {10} xl ={1} className ="text-center">
                                <Button color="secondary" id="botonCancelar" onClick={() => CerrarModal()}>Cerrar</Button>
                            </Col>
                            
                        </Row>
                        
                    </React.Fragment>
                }




            </ModalBody>

        </Modal>
    )
}
export default ModalFirmarReporteAnual
